// pages/RestaurantMenu.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import keywordsData from '../lang/keywords.json';
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Chip,
  Avatar,
  Divider,
  Skeleton,
  Paper,
  IconButton,
  Tab,
  Tabs,
  Rating,
  Alert,
  Snackbar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  InputAdornment,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,useTheme,useMediaQuery
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  LocationOn as LocationIcon,
  AccessTime as TimeIcon,
  DeliveryDining as DeliveryIcon,
  Star as StarIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Share as ShareIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  Storefront as StorefrontIcon,
  Info as InfoIcon,
  RateReview as ReviewIcon,
  ExpandMore as ExpandMoreIcon,
  Send as SendIcon,
  Person as PersonIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Flag as FlagIcon,
  Cancel as CancelIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
import { useLanguage } from '../context/LanguageContext';
import api from '../services/api';
import ProductCard from '../components/ProductCard';
import CrossRestaurantDialog from '../components/CrossRestaurantDialog';
import { formatPrice } from '../components/CarrancyTrans';
import TablePersonDialog from '../components/TablePersonDialog';
import LimitInfoModal from '../components/LimitInfoModal';

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`restaurant-tabpanel-${index}`}
      aria-labelledby={`restaurant-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const RestaurantMenu = () => {
  const { id, tableId } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const { 
    addToCart, snackbar, handleCloseSnackbar, setTableScan,
    setVipTableInfo, currentOrder, isOrder,clearCart,
    resetTable, clearVipTableInfo, openLimitModel, setOpenLimitModel,
    getCartCount, cartItems
  } = useCart();
  const { language } = useLanguage();
  const [selectedPro, setSelectedPro] = useState(null);
  const [deliverStatus, setDeliverStatus] = useState(false);

  const [restaurant, setRestaurant] = useState(null);
  const [menuCategories, setMenuCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [infoTabValue, setInfoTabValue] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [crossRestaurantDialogOpen, setCrossRestaurantDialogOpen] = useState(false);
  const [currentCartRestaurant, setCurrentCartRestaurant] = useState(localStorage.getItem('current_rest_id') || id);
  const [reviews, setReviews] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [newReview, setNewReview] = useState({ rating: 0, comment: '' });
  const [submittingReview, setSubmittingReview] = useState(false);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [personDialogOpen, setPersonDialogOpen] = useState(false);
  const [tableNumber, setTableNumber] = useState(null);
  const currentTableId = localStorage.getItem('tableId') || 0;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTableScan = (scannedTableNumber) => {
    setTableScan(scannedTableNumber);
    setTableNumber(scannedTableNumber);
    localStorage.setItem('current_rest_id_now', id);
    navigate(`../restaurant/${id}`);
    setPersonDialogOpen(true);
  };
  // Fetch restaurant menu on mount
  useEffect(() => {
    if (Number(tableId)) {
      handleTableScan(tableId);
    }
    fetchRestaurantMenu();
    fetchReviews();
  }, [id, tableId]);

  const checkTableSession = () => {
    const tableIdS = localStorage.getItem('tableId');
    const tableStartTime = localStorage.getItem('tableStartTime');
    if (tableIdS && tableStartTime) {
      const elapsed = Date.now() - parseInt(tableStartTime);
      const THREE_HOURS = 3 * 60 * 60 * 1000;
      
      if (elapsed >= THREE_HOURS) {
        resetTable();
        return false;
      }
      //registerTable(tableIdS);
    }
    return true;
  };


  useEffect(() => {
    checkTableSession();
  }, []);

  const fetchRestaurantMenu = async () => {
    try {
      setLoading(true);

      // Fetch menu categories with products
      const [menuResponse, detailsResponse] = await Promise.all([
        api.get(`/restaurants/${id}/menu`),
        api.get(`/restaurants/${id}`).catch(() => null)
      ]);

      if (menuResponse.data.success) {
        setMenuCategories(menuResponse.data.categories || []);
      }

      if (detailsResponse?.data?.success) {
        setRestaurant(detailsResponse.data.restaurant);
        setDeliverStatus(detailsResponse.data.restaurant?.menu_settings?.deliver_status || false);
      } else {
        // Fallback to basic info
        setRestaurant({
          id,
          name: 'Restaurant',
          name_en: 'Restaurant',
          rating: 4.5,
          total_reviews: 0,
          delivery_time_min: 30,
          delivery_fee: 5,
          min_order_amount: 20,
          phone: '',
          email: '',
          address: '',
          city: '',
          area: '',
          currency: 'MYR',
          menu_settings: { is_open: true },
          subscription: { is_active: true, status: 'active' }
        });
      }

    } catch (err) {
      console.error('Error fetching Store menu:', err);
      setError(err.response?.data?.message || 'Failed to load Store menu');
    } finally {
      setLoading(false);
    }
  };

  const fetchReviews = async () => {
    setReviewsLoading(true);
    try {
      const response = await api.get(`/restaurants/${id}/reviews`);
      if (response.data.success) {
        setReviews(response.data.reviews || []);
      }
    } catch (err) {
      console.error('Error fetching reviews:', err);
    } finally {
      setReviewsLoading(false);
    }
  };

  const submitReview = async () => {
    if (newReview.rating === 0) {
      return;
    }
    setSubmittingReview(true);
    try {
      const response = await api.post(`/restaurants/${id}/reviews`, newReview);
      if (response.data.success) {
        setReviews([response.data.review, ...reviews]);
        setNewReview({ rating: 0, comment: '' });
        // Refresh restaurant to update rating
        const detailsResponse = await api.get(`/restaurants/${id}`);
        if (detailsResponse.data.success) {
          setRestaurant(detailsResponse.data.restaurant);
        }
      }
    } catch (err) {
      console.error('Error submitting review:', err);
    } finally {
      setSubmittingReview(false);
    }
  };

  const addToCartSet = async (o,product_limit = 0,card_limit = 0) => {
    // Check if subscription is active before adding to cart
    if (restaurant?.subscription && !restaurant.subscription.is_active) {
      setSubscriptionDialogOpen(true);
      return;
    }
    
    const restID = localStorage.getItem('current_rest_id');
    if (restID && restID !== id) {
      setCrossRestaurantDialogOpen(true);
    } else {
      localStorage.setItem('current_rest_id', id);
      setCurrentCartRestaurant(id);
      await addToCart(o, 1, null, [], product_limit,card_limit);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleInfoTabChange = (event, newValue) => {
    setInfoTabValue(newValue);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };

  // Check if subscription is active
  const isSubscriptionActive = restaurant?.subscription?.is_active === true;
  const subscriptionStatus = restaurant?.subscription?.status;
  const remainingDays = restaurant?.subscription?.remaining_days;

  // Subscription Expired Component
  const SubscriptionExpiredMessage = () => (
    <Paper sx={{
      p: 6,
      textAlign: 'center',
      bgcolor: '#0D0D0D',
      border: '2px solid #FF3D00',
      borderRadius: '24px',
      mb: 4
    }}>
      <WarningIcon sx={{ fontSize: 80, color: '#FF3D00', mb: 2 }} />
      <Typography variant="h4" sx={{ color: '#FFD700', fontWeight: 800, mb: 2 }}>
        {language === 'ar' ? 'الاشتراك منتهي' : 'Subscription Expired'}
      </Typography>
      <Typography variant="body1" sx={{ color: '#FFFFFF', mb: 3 }}>
        {language === 'ar' 
          ? 'عذراً، اشتراك هذا المتجر قد انتهى. لا يمكن عرض المنتجات أو إضافة عناصر إلى السلة حالياً.'
          : 'Sorry, this store\'s subscription has expired. Products cannot be displayed or added to cart at this time.'}
      </Typography>
      <Typography variant="body2" sx={{ color: '#B3B3B3', mb: 4 }}>
        {language === 'ar' 
          ? 'يرجى التواصل مع إدارة المتجر لتجديد الاشتراك.'
          : 'Please contact the store management to renew the subscription.'}
      </Typography>
      <Button
        variant="contained"
        onClick={handleGoBack}
        sx={{
          backgroundColor: '#FFD700',
          color: '#000000',
          fontWeight: 700,
          px: 4,
          py: 1.5,
          '&:hover': { backgroundColor: '#FFE55C' }
        }}
      >
        {language === 'ar' ? 'العودة إلى الرئيسية' : 'Back to Home'}
      </Button>
    </Paper>
  );

  // Subscription Expiring Soon Message
  const SubscriptionExpiringMessage = () => (
    <Alert
      severity="warning"
      sx={{
        mb: 3,
        backgroundColor: 'rgba(255, 152, 0, 0.1)',
        color: '#FF9800',
        border: '1px solid #FF9800',
        borderRadius: '12px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <WarningIcon />
        <Typography variant="body2">
          {language === 'ar' 
            ? `⚠️ تنبيه: اشتراك المتجر سينتهي قريباً! متبقي ${remainingDays} يوم.`
            : `⚠️ Alert: Store subscription expires soon! ${remainingDays} days remaining.`}
        </Typography>
      </Box>
    </Alert>
  );

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, mb: 10 }}>
        <Skeleton variant="rectangular" height={200} sx={{ bgcolor: '#1A1A1A', borderRadius: 3, mb: 3 }} />
        <Skeleton variant="rectangular" height={50} sx={{ bgcolor: '#1A1A1A', borderRadius: 3, mb: 3 }} />
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map(i => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Skeleton variant="rectangular" height={250} sx={{ bgcolor: '#1A1A1A', borderRadius: 3 }} />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 4, mb: 10 }}>
        <Alert severity="error" sx={{ mb: 3, bgcolor: '#0D0D0D', color: '#FF3D00', border: '1px solid #FF3D00' }}>
          {error}
        </Alert>
        <Button
          startIcon={language === 'ar' ? <ArrowForwardIcon /> : <ArrowBackIcon />}
          onClick={handleGoBack}
          sx={{ color: '#FFD700' }}
        >
          {language === 'ar' ? 'العودة' : 'Go Back'}
        </Button>
      </Container>
    );
  }

  // If subscription is expired, show expired message
  if (restaurant && !isSubscriptionActive) {
    return (
      <Box sx={{ backgroundColor: '#000000', minHeight: '100vh', pb: 10 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <SubscriptionExpiredMessage />
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: '#000000', minHeight: '100vh', pb: 10 }}>
      {/* Restaurant Header */}
      <Box sx={{
        background: 'linear-gradient(135deg, #0D0D0D 0%, #1A1A1A 100%)',
        borderBottom: '2px solid #FFD700',
        py: 3,
        mb: 3
      }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              onClick={handleGoBack}
              sx={{ color: '#FFD700' }}
            >
              {language === 'ar' ? <ArrowForwardIcon /> : <ArrowBackIcon />}
            </IconButton>
            <Typography variant="h5" sx={{ color: '#FFD700', fontWeight: 700 }}>
              {language === 'ar' ? 'قائمة المتجر' : 'Store Menu'}
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg">
        {/* Show expiring soon warning if applicable */}
        {restaurant && subscriptionStatus === 'expiring_soon' && (
          <SubscriptionExpiringMessage />
        )}

        {/* Restaurant Info Card with Tabs */}
        {restaurant && (
          <Paper sx={{
            p: 3,
            mb: 4,
            bgcolor: '#0D0D0D',
            border: '1px solid #2D2D2D',
            borderRadius: '16px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Open Status Banner */}
            <Box sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              background: restaurant.menu_settings?.is_open
                ? 'linear-gradient(135deg, #4CAF50, #45a049)'
                : 'linear-gradient(135deg, #FF3D00, #D32F2F)',
              px: 3,
              py: 0.8,
              borderBottomLeftRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}>
              <Box sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                animation: restaurant.menu_settings?.is_open ? 'pulse 1.5s infinite' : 'none'
              }} />
              <Typography variant="caption" sx={{
                color: '#FFFFFF',
                fontWeight: 700,
                fontSize: '0.75rem'
              }}>
                {restaurant.menu_settings?.is_open
                  ? (language === 'ar' ? 'مفتوح الآن' : 'Open Now')
                  : (language === 'ar' ? 'مغلق' : 'Closed')}
              </Typography>
            </Box>

            {/* Store Info Tabs */}
            <Tabs
              value={infoTabValue}
              onChange={handleInfoTabChange}
              variant="fullWidth"
              sx={{
                mb: 3,
                '& .MuiTab-root': {
                  color: '#B3B3B3',
                  fontWeight: 600,
                  fontSize: '1rem',
                  '&.Mui-selected': {
                    color: '#FFD700'
                  }
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#FFD700'
                }
              }}
            >
              <Tab icon={<StorefrontIcon />} label={language === 'ar' ? 'القائمة' : 'Menu'} />
              <Tab icon={<InfoIcon />} label={language === 'ar' ? 'معلومات المتجر' : 'Store Info'} />
              <Tab icon={<ReviewIcon />} label={language === 'ar' ? 'التقييمات' : 'Reviews'} />
            </Tabs>

            {/* Tab 1: Current Menu */}
            <TabPanel value={infoTabValue} index={0}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} sm={3}>
                  <Avatar
                    src={restaurant.logo}
                    sx={{
                      width: 120,
                      height: 120,
                      border: '3px solid #FFD700',
                      bgcolor: '#1A1A1A',
                      mx: 'auto'
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="h4" sx={{ color: '#FFD700', fontWeight: 800, mb: 1 }}>
                    {language === 'ar' ? restaurant.name : restaurant.name_en}
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <StarIcon sx={{ color: '#FFD700', fontSize: 20 }} />
                      <Typography sx={{ color: '#FFFFFF' }}>
                        {restaurant.rating || '4.5'} ({restaurant.total_reviews || 0})
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <TimeIcon sx={{ color: '#FFD700', fontSize: 20 }} />
                      <Typography sx={{ color: '#FFFFFF' }}>
                        {restaurant.delivery_time_min || '30'} {language === 'ar' ? 'دقيقة' : 'min'}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <DeliveryIcon sx={{ color: '#FFD700', fontSize: 20 }} />
                      <Typography sx={{ color: '#FFFFFF' }}>
                        {formatPrice(restaurant.delivery_fee || '5', restaurant.currency, language)} {language === 'ar' ? 'توصيل' : 'delivery'}
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body2" sx={{ color: '#B3B3B3' }}>
                    {language === 'ar' ? 'الحد الأدنى للطلب: ' : 'Minimum order: '}
                    {formatPrice(restaurant.min_order_amount || '20', restaurant.currency, language)}
                  </Typography>

                  {!restaurant.menu_settings?.is_open && (
                    <Box sx={{
                      mt: 2,
                      p: 1.5,
                      bgcolor: 'rgba(255, 61, 0, 0.1)',
                      borderRadius: '8px',
                      border: '1px solid #FF3D00'
                    }}>
                      <Typography variant="caption" sx={{ color: '#FF3D00', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TimeIcon sx={{ fontSize: 16 }} />
                        {language === 'ar'
                          ? 'المتجر مغلق حالياً. ساعات العمل: '
                          : 'Store is currently closed. Business hours: '}
                        {restaurant.opening_hours?.monday?.open || '09:00'} - {restaurant.opening_hours?.monday?.close || '23:00'}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </TabPanel>

            {/* Tab 2: Store Info (Phone, Location, etc.) */}
            <TabPanel value={infoTabValue} index={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2 }}>
                    {language === 'ar' ? 'معلومات الاتصال' : 'Contact Information'}
                  </Typography>
                  <List sx={{ bgcolor: '#1A1A1A', borderRadius: '12px', p: 0 }}>
                    <ListItem>
                      <ListItemIcon><PhoneIcon sx={{ color: '#FFD700' }} /></ListItemIcon>
                      <ListItemText
                        primary={restaurant.phone}
                        primaryTypographyProps={{ sx: { color: '#FFFFFF' } }}
                      />
                    </ListItem>
                    <Divider sx={{ bgcolor: '#2D2D2D' }} />
                    <ListItem>
                      <ListItemIcon><EmailIcon sx={{ color: '#FFD700' }} /></ListItemIcon>
                      <ListItemText
                        primary={restaurant.email}
                        primaryTypographyProps={{ sx: { color: '#FFFFFF' } }}
                      />
                    </ListItem>
                  </List>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2 }}>
                    {language === 'ar' ? 'الموقع' : 'Location'}
                  </Typography>
                  <List sx={{ bgcolor: '#1A1A1A', borderRadius: '12px', p: 0 }}>
                    <ListItem>
                      <ListItemIcon><LocationIcon sx={{ color: '#FFD700' }} /></ListItemIcon>
                      <ListItemText
                        primary={restaurant.address}
                        secondary={restaurant.city ? `${restaurant.city}${restaurant.area ? ` - ${restaurant.area}` : ''}` : ''}
                        secondaryTypographyProps={{ sx: { color: '#B3B3B3' } }}
                        primaryTypographyProps={{ sx: { color: '#FFFFFF' } }}
                      />
                    </ListItem>
                  </List>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2 }}>
                    {language === 'ar' ? 'ساعات العمل' : 'Business Hours'}
                  </Typography>
                  <Box sx={{ bgcolor: '#1A1A1A', borderRadius: '12px', p: 2 }}>
                    {restaurant.opening_hours && Object.keys(restaurant.opening_hours).map((day) => {
                      const hours = restaurant.opening_hours[day];
                      const dayNames = {
                        monday: language === 'ar' ? 'الاثنين' : 'Monday',
                        tuesday: language === 'ar' ? 'الثلاثاء' : 'Tuesday',
                        wednesday: language === 'ar' ? 'الأربعاء' : 'Wednesday',
                        thursday: language === 'ar' ? 'الخميس' : 'Thursday',
                        friday: language === 'ar' ? 'الجمعة' : 'Friday',
                        saturday: language === 'ar' ? 'السبت' : 'Saturday',
                        sunday: language === 'ar' ? 'الأحد' : 'Sunday'
                      };
                      return (
                        <Box key={day} sx={{ display: 'flex', justifyContent: 'space-between', py: 1, borderBottom: '1px solid #2D2D2D' }}>
                          <Typography sx={{ color: '#FFFFFF', fontWeight: 500 }}>{dayNames[day]}</Typography>
                          <Typography sx={{ color: '#B3B3B3' }}>
                            {hours?.closed ? (language === 'ar' ? 'مغلق' : 'Closed') : `${hours?.open || '09:00'} - ${hours?.close || '23:00'}`}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </TabPanel>

            {/* Tab 3: Rating and Reviews */}
            <TabPanel value={infoTabValue} index={2}>
              <Grid container spacing={3}>
                {/* Rating Summary */}
                <Grid item xs={12} md={4}>
                  <Box sx={{
                    textAlign: 'center',
                    p: 3,
                    bgcolor: '#1A1A1A',
                    borderRadius: '16px'
                  }}>
                    <Typography variant="h2" sx={{ color: '#FFD700', fontWeight: 800 }}>
                      {restaurant.rating || '4.5'}
                    </Typography>
                    <Rating value={parseFloat(restaurant.rating) || 4.5} precision={0.5} readOnly sx={{ color: '#FFD700', mb: 1 }} />
                    <Typography sx={{ color: '#B3B3B3' }}>
                      {language === 'ar' ? `بناءً على ${restaurant.total_reviews || 0} تقييم` : `Based on ${restaurant.total_reviews || 0} reviews`}
                    </Typography>
                  </Box>
                </Grid>

                {/* Write Review */}
                <Grid item xs={12} md={8}>
                  <Box sx={{
                    p: 3,
                    bgcolor: '#1A1A1A',
                    borderRadius: '16px'
                  }}>
                    <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2 }}>
                      {language === 'ar' ? 'اكتب تقييمك' : 'Write a Review'}
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Rating
                        value={newReview.rating}
                        onChange={(e, val) => setNewReview({ ...newReview, rating: val || 0 })}
                        sx={{ color: '#FFD700' }}
                        size="large"
                      />
                    </Box>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder={language === 'ar' ? 'شارك تجربتك مع هذا المتجر...' : 'Share your experience with this store...'}
                      value={newReview.comment}
                      onChange={(e) => setNewReview({ ...newReview, comment: e.target.value })}
                      sx={{
                        mb: 2,
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#0D0D0D',
                          color: '#FFFFFF',
                          '& fieldset': { borderColor: '#2D2D2D' },
                          '&:hover fieldset': { borderColor: '#FFD700' },
                          '&.Mui-focused fieldset': { borderColor: '#FFD700' }
                        }
                      }}
                    />
                    <Button
                      variant="contained"
                      startIcon={submittingReview ? <CircularProgress size={20} /> : <SendIcon />}
                      onClick={submitReview}
                      disabled={newReview.rating === 0 || submittingReview}
                      sx={{
                        backgroundColor: '#FFD700',
                        color: '#000000',
                        fontWeight: 600,
                        '&:hover': { backgroundColor: '#FFE55C' }
                      }}
                    >
                      {language === 'ar' ? 'نشر التقييم' : 'Submit Review'}
                    </Button>
                  </Box>
                </Grid>

                {/* Reviews List */}
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ color: '#FFD700', fontWeight: 700, mb: 2 }}>
                    {language === 'ar' ? 'تقييمات العملاء' : 'Customer Reviews'}
                  </Typography>
                  {reviewsLoading ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                      <CircularProgress sx={{ color: '#FFD700' }} />
                    </Box>
                  ) : reviews.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4, bgcolor: '#1A1A1A', borderRadius: '16px' }}>
                      <Typography sx={{ color: '#B3B3B3' }}>
                        {language === 'ar' ? 'لا توجد تقييمات بعد. كن أول من يقيم!' : 'No reviews yet. Be the first to review!'}
                      </Typography>
                    </Box>
                  ) : (
                    reviews.map((review, index) => (
                      <Accordion
                        key={review.id || index}
                        sx={{
                          bgcolor: '#1A1A1A',
                          mb: 2,
                          borderRadius: '12px !important',
                          '&:before': { display: 'none' },
                          border: '1px solid #2D2D2D'
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FFD700' }} />}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                            <Avatar sx={{ bgcolor: '#FFD700', color: '#000000' }}>
                              <PersonIcon />
                            </Avatar>
                            <Box>
                              <Typography sx={{ color: '#FFFFFF', fontWeight: 600 }}>
                                {review.user?.username || 'Anonymous'}
                              </Typography>
                              <Rating value={review.rating} readOnly size="small" sx={{ color: '#FFD700' }} />
                            </Box>
                            <Typography variant="caption" sx={{ color: '#B3B3B3' }}>
                              {new Date(review.created_at).toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US')}
                            </Typography>
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography sx={{ color: '#FFFFFF', lineHeight: 1.6 }}>
                            {review.comment}
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button size="small" startIcon={<ThumbUpIcon />} sx={{ color: '#B3B3B3' }}>
                              {language === 'ar' ? 'مفيد' : 'Helpful'}
                            </Button>
                            <Button size="small" startIcon={<FlagIcon />} sx={{ color: '#B3B3B3' }}>
                              {language === 'ar' ? 'إبلاغ' : 'Report'}
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))
                  )}
                </Grid>
              </Grid>
            </TabPanel>
          </Paper>
        )}

        {/* Menu Categories Tabs - Only show when on Menu tab and subscription is active */}
        {infoTabValue === 0 && isSubscriptionActive && menuCategories.length > 0 ? (
          <>
            <Box sx={{ borderBottom: 1, borderColor: '#2D2D2D', mb: 3, overflowX: 'auto' }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  '& .MuiTab-root': {
                    color: '#B3B3B3',
                    fontWeight: 600,
                    '&.Mui-selected': {
                      color: '#FFD700'
                    }
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#FFD700'
                  }
                }}
              >
                <Tab label={language === 'ar' ? 'الكل' : 'All Items'} />
                {menuCategories.map((category) => (
                  <Tab
                    key={category.id}
                    label={language === 'ar' ? category.name : category.name_en}
                  />
                ))}
              </Tabs>
            </Box>

            {/* All Items Tab */}
            <TabPanel value={tabValue} index={0}>
              {menuCategories.map((category) => (
                <Box key={category.id} sx={{ mb: 5 }} id={`category-${category.id}`}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: '#FFD700',
                      fontWeight: 700,
                      mb: 2,
                      borderBottom: '2px solid #FFD700',
                      pb: 1,
                      display: 'inline-block'
                    }}
                  >
                    {language === 'ar' ? category.name : category.name_en}
                  </Typography>

                  {category.products && category.products.length > 0 ? (
                    <Grid container spacing={isMobile ? 1.5 : 2}>
                      {category.products.map((product) => (
                          <ProductCard
                            key={`${product.id}-${product.created_at}`}
                            product={product}
                            addToCart={(o,l,lc) => addToCartSet(o,l,lc)}
                            keywordsData={keywordsData}
                            language={language}
                            restaurantId={id}
                            deliverStatus={deliverStatus}
                            tableScan={localStorage.getItem('tableId') || 0}
                            setSelectedPro={(e) => setSelectedPro(e)}
                            currency={restaurant.currency}
                          />
                      ))}
                    </Grid>
                  ) : (
                    <Typography sx={{ color: '#B3B3B3', textAlign: 'center', py: 4 }}>
                      {language === 'ar' ? 'لا توجد منتجات في هذا القسم' : 'No products in this category'}
                    </Typography>
                  )}
                </Box>
              ))}
            </TabPanel>

            {/* Individual Category Tabs */}
            {menuCategories.map((category, index) => (
              <TabPanel key={category.id} value={tabValue} index={index + 1}>
                <Typography
                  variant="h5"
                  sx={{
                    color: '#FFD700',
                    fontWeight: 700,
                    mb: 3,
                    borderBottom: '2px solid #FFD700',
                    pb: 1,
                    display: 'inline-block'
                  }}
                >
                  {language === 'ar' ? category.name : category.name_en}
                </Typography>

                {category.products && category.products.length > 0 ? (
                    <Grid container spacing={isMobile ? 1.5 : 2}>
                    {category.products.map((product) => (
                        <ProductCard
                          key={`${product.id}-${product.created_at}`}
                          product={product}
                          addToCart={(o,l,lc) => addToCartSet(o,l,lc)}
                          keywordsData={keywordsData}
                          language={language}
                          restaurantId={id}
                          deliverStatus={deliverStatus}
                          tableScan={localStorage.getItem('tableId') || 0}
                          setSelectedPro={(e) => setSelectedPro(e)}
                          currency={restaurant.currency}
                        />
                    ))}
                  </Grid>
                ) : (
                  <Typography sx={{ color: '#B3B3B3', textAlign: 'center', py: 8 }}>
                    {language === 'ar' ? 'لا توجد منتجات في هذا القسم' : 'No products in this category'}
                  </Typography>
                )}
              </TabPanel>
            ))}
          </>
        ) : infoTabValue === 0 && isSubscriptionActive ? (
          <Paper sx={{ p: 8, textAlign: 'center', bgcolor: '#0D0D0D', border: '1px solid #2D2D2D' }}>
            <Typography variant="h6" sx={{ color: '#B3B3B3', mb: 2 }}>
              {language === 'ar' ? 'لا توجد منتجات في هذا المتجر' : 'No products in this store'}
            </Typography>
            <Button
              variant="outlined"
              onClick={handleGoBack}
              sx={{ borderColor: '#FFD700', color: '#FFD700' }}
            >
              {language === 'ar' ? 'العودة' : 'Go Back'}
            </Button>
          </Paper>
        ) : null}

        {/* Subscription Expired Dialog */}
        <Dialog
          open={subscriptionDialogOpen}
          onClose={() => setSubscriptionDialogOpen(false)}
          PaperProps={{
            sx: {
              backgroundColor: '#0D0D0D',
              border: '2px solid #FF3D00',
              borderRadius: '20px',
              maxWidth: '400px'
            }
          }}
        >
          <DialogTitle sx={{ color: '#FFD700', borderBottom: '1px solid #2D2D2D' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WarningIcon sx={{ color: '#FF3D00' }} />
              {language === 'ar' ? 'اشتراك منتهي' : 'Subscription Expired'}
            </Box>
          </DialogTitle>
          <DialogContent sx={{ py: 3 }}>
            <Typography sx={{ color: '#FFFFFF', mb: 2 }}>
              {language === 'ar'
                ? 'عذراً، لا يمكن إضافة المنتجات إلى السلة لأن اشتراك هذا المتجر قد انتهى.'
                : 'Sorry, products cannot be added to cart because this store\'s subscription has expired.'}
            </Typography>
            <Typography sx={{ color: '#B3B3B3' }}>
              {language === 'ar'
                ? 'يرجى التواصل مع إدارة المتجر لتجديد الاشتراك.'
                : 'Please contact the store management to renew the subscription.'}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ borderTop: '1px solid #2D2D2D', p: 2 }}>
            <Button
              onClick={() => setSubscriptionDialogOpen(false)}
              sx={{ color: '#B3B3B3' }}
            >
              {language === 'ar' ? 'إغلاق' : 'Close'}
            </Button>
            <Button
              onClick={() => {
                setSubscriptionDialogOpen(false);
                handleGoBack();
              }}
              variant="contained"
              sx={{
                backgroundColor: '#FFD700',
                color: '#000000',
                '&:hover': { backgroundColor: '#FFE55C' }
              }}
            >
              {language === 'ar' ? 'العودة' : 'Go Back'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for status updates */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{
              backgroundColor: '#0D0D0D',
              color: '#FFFFFF',
              border: '1px solid #FFD700',
              borderRadius: '12px',
              fontWeight: 600,
              '& .MuiAlert-icon': {
                color: snackbar.severity === 'success' ? '#FFD700' : '#FF3D00',
              },
              '& .MuiAlert-action': {
                color: '#B3B3B3',
              }
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        <LimitInfoModal
          open={openLimitModel}
          onClose={() => setOpenLimitModel(false)}
          language={language}
          product={selectedPro}
        />
        <TablePersonDialog
          open={personDialogOpen}
          onClose={() => {}}
          onConfirm={(personCount, tableInfo) => {
            console.log('Person count:', personCount);
            console.log('Table info:', tableInfo);
            clearVipTableInfo();
            localStorage.setItem('table_persons', personCount);
            localStorage.setItem('tableId', tableNumber);
            localStorage.setItem('tableStartTime', Date.now().toString());
            setPersonDialogOpen(false);
            //registerTable(tableNumber);
            if (tableInfo.is_vip && tableInfo.min_charge > 0) {
              setVipTableInfo(tableInfo);
            }
          }}
          language={language}
          tableNumber={tableNumber}
          tableId={tableNumber}
          restId={id}
          maxPersons={30}
          minPersons={1}
          disableBackdropClose={true}
          disableEscapeKeyClose={true}
          currency={restaurant.currency}
        />

        <CrossRestaurantDialog
          open={crossRestaurantDialogOpen}
          onClose={() => setCrossRestaurantDialogOpen(false)}
          onConfirmClear={clearCart}
          currentCartRestaurant={currentCartRestaurant}
          newRestaurant={id}
          language={language}
        />
      </Container>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes pulse {
          0% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.1); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </Box>
  );
};

export default RestaurantMenu;